import {Form} from '@esgi/ui/form';
import {styled} from '@esgi/ui/theme';

export const StyledForm = styled(Form, {
	display: 'grid',
	gridAutoFlow: 'column',
	gap: '$3',
});
